import AdditionalStepsPage from './AdditionalSteps';
export default AdditionalStepsPage;
